import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { PauseIcon } from '@change/ds-icons/PauseIcon';
import { PlayArrowIcon } from '@change/ds-icons/PlayArrowIcon';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	isPlaying: boolean;
	onClick: () => void;
}>;

export const PlayPauseButton: React.FC<Props> = ({ isPlaying, onClick }) => {
	const { translate } = useI18n();

	return (
		<Button
			iconOnly
			variant="tertiary"
			size="x-small"
			leadingIcon={isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
			aria-label={
				isPlaying
					? translate('corgi.homepage.petition_marquee.pause_button_label')
					: translate('corgi.homepage.petition_marquee.play_button_label')
			}
			data-testid="petition-marquee-play-pause-button"
			data-qa="petition-marquee-play-pause-button"
			onClick={onClick}
		/>
	);
};
